import React, { useState, useEffect } from "react";
import { getData } from "../../../../serverRequest";
import LoadingSpinner from "../../../../components/Loadder";
//import moment from 'moment';
import { Link } from 'react-router-dom';
import Select from 'react-select';

// components
import IncidentListTable from "../../../../components/Tables/IncidentListTable";

export default function IncidentList() {
    //const [open, setOpen] = React.useState(true);
    const [incidents, setIncidents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isSuperadmin, setSuperadmin] = React.useState(JSON.parse(localStorage.getItem('companyAdmin')));
    const [employees, setEmployees] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedEmployee, setSelectedEmployee] = useState(localStorage.getItem('employeeId'));
    //const searchParams = new URLSearchParams(window.location.search);

    /* const ticketFilter = searchParams.get('filter');
    //console.log(ticketFilter);
    const toggleDrawer = () => {
      setOpen(!open);
    };
  
    const formatDate = (dateString) => {
      return moment(dateString).format('DD/MM/YYYY');
    }; */
    const filterEmployeeData = (employee_data) => {
        //console.log(tickets_data);
        let totalEmployee = [];
        if (employee_data) {
            for (let i = 0; i < employee_data.length; i++) {
                totalEmployee.push(employee_data[i])
            }
        }

        setEmployees(totalEmployee);
        return ({ "total": totalEmployee })
    }
    const filterIncidentData = (incident_data) => {
        let totalIncidents = [];
        if (incident_data) {
            for (let i = 0; i < incident_data.length; i++) {
                totalIncidents.push(incident_data[i])
            }
        }

        setIncidents(totalIncidents);
        return ({ "total": incidents })
    }

    async function fetchData() {
        setLoading(true);
        let resData = await getData(
            '/api/employee/daily_incident/?employee_id=' +
            selectedEmployee
        );
        let incident_data = resData['data']['incident_data']
        console.log(incident_data);
        let incidentData = await filterIncidentData(incident_data)

        setLoading(false);
    }

    async function fetchEmployeeData() {
        let resData = await getData('/api/employee/?company_id=' + localStorage.getItem('companyId') + '&is_list_employee=1');
        //let resData = await getData('/api/employee/admins/?is_admin=1')
        let employee_data = resData['data']['employee_data']
        console.log(employee_data);
        let adminData = await filterEmployeeData(employee_data)


        setLoading(false);
    }


    useEffect(() => {

        fetchEmployeeData();
        fetchData();
    }, [])

    return (
        <>

            <main>
                <div className="relative block py-24 lg:pt-0 px-4">
                    <div className="rounded-t bg-white mb-0 px-6 py-6">
                        <div className="text-center flex justify-between">
                            <h6 className="text-blueGray-700 text-xl font-bold">Incident Report</h6>
                            {isSuperadmin && (
                                <div className="w-full lg:w-4/12 px-4">
                                    <div className="relative w-full">
                                        <Select name="clist"
                                            options={employees.map(employee => ({
                                                label: `${employee.first_name} ${employee.last_name}`,
                                                value: employee.id
                                            }))}
                                            getOptionLabel={(option) => option.label}
                                            getOptionValue={(option) => option.value}
                                            value={selectedOption}
                                            onChange={(selectedOption) => {
                                                setSelectedOption(selectedOption);
                                                setSelectedEmployee(selectedOption.value);
                                                fetchData();
                                                //console.log(selectedOption.value);
                                                //window.location.reload();
                                            }}
                                            placeholder="Select Employee">
                                        </Select>
                                    </div>
                                </div>
                            )}
                            <Link to="/admin/company/incidentForm">
                                <button
                                    className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                    type="button">
                                    Add
                                </button>
                            </Link>
                        </div>
                    </div>
                    {loading ? (
                        <LoadingSpinner></LoadingSpinner>
                    ) : (<>
                        <div
                            className={
                                "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                                ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
                            }
                        >

                            <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                                {/* Projects table */}
                                {!loading && incidents.length > 0 ? (
                                    <IncidentListTable
                                        key={incidents.length} // Add a unique key to force re-render
                                        totalIncidents={incidents}
                                    ></IncidentListTable>
                                ) : (
                                    <div className="text-center py-4">No data available</div>
                                )}

                            </div>
                        </div>
                    </>)}
                </div>
            </main>

        </>
    );
}
